import React from 'react';

export const LinkTableMenu = ({ selectedParticipant, children }) => {
  return selectedParticipant.length ? (
    <div className="worklist-selected-patients-menu">
      <div>{`${selectedParticipant.length} Patients selected`}</div>
      <div>{children}</div>
    </div>
  ) : (
    <div className="menu-place-holder" />
  );
};
